import {inject} from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import {catchError, Observable, of, tap, throwError} from 'rxjs';
import {LoggerService} from './logger.service';
import {NotificationService} from './notification.service';
import {Router} from '@angular/router';
import {CacheService} from './cache.service';
import { StorageService } from './storage.service';
import { environment } from '../../environments/environment';

export const HttpRequestInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loggerService = inject(LoggerService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);
  const cacheService = inject(CacheService);
  const localStorage = inject(StorageService);

  const path = router.routerState.snapshot.url;

  const token = localStorage.retrieveFromLocal("token");

  const headers = {

  };

  let jwtToken = request.clone({
    setHeaders: headers
  });


  if (request.method === 'GET' && localStorage.retrieveFromLocal('token')) {
    if (request.headers.get('cache-response')) {
      const cachedResponse = cacheService.getFromCache(request);
      if (cachedResponse) {
        return cachedResponse instanceof Observable
          ? cachedResponse
          : of(cachedResponse.clone());
      }

      return next(jwtToken).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            cacheService.addToCache(jwtToken, event);
          }
        })
      );
    } else {
      if (cacheService.cacheMap.get(request.urlWithParams)) {
        cacheService.cacheMap.delete(request.urlWithParams);
      }
    }
  }

  return next(jwtToken).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {

      }

      if (error instanceof HttpErrorResponse) {
        loggerService.error(path, error);
        if (error.error?.data?.errors) {
          let message = '';
          let index = 0;
          for (let aObj in error.error?.data?.errors) {
            index = index + 1;
            message += index + '. ' + error.error.data.errors[aObj] + '\n';
          }
          notificationService.ErrorNotification(message);
        } else if (error.status === 0) {
          notificationService.ErrorNotification(
            'Timeout. Please contact with dev team'
          );
        } else {
          // Don't show notification for pagination errors - let components handle them
          const isPaginationError = error.error?.code === 'rest_post_invalid_page_number' ||
                                   (error.status === 400 && error.error?.message?.includes('larger than the number of pages'));

          if (!isPaginationError) {
            if (error.error?.message)
              notificationService.ErrorNotification(error.error.message);
            else notificationService.ErrorNotification(error.error?.error || 'An error occurred');
          }
        }
      }
      return throwError(() => error);
    })
  );
};
